import Vue from 'vue'
import User from './models/User'
import App from './modules/App/App.vue'
import ConfirmModal from './plugins/ConfirmModal'
import router from './routes'
import VueAdmin from '@western-investment/vue-admin'
import Plugins from './plugins/plugins'
import VeeValidate from 'vee-validate'
import VueAxios from 'vue-axios'
import axios from 'axios'
import { loadProgressBar } from 'axios-progress-bar'
import 'axios-progress-bar/dist/nprogress.css'
import store from './store'
import ApiPlugin from './services/api'

Vue.config.productionTip = false

Vue.use(VueAxios, axios)
Vue.axios.defaults.baseURL = 'https://app.kaminatrans.lt/api'
//Vue.axios.defaults.baseURL = 'https://localhost:5001'
Vue.use(VueAdmin)
Vue.use(Plugins)
Vue.use(VeeValidate)
Vue.use(ApiPlugin)
Vue.use(ConfirmModal)
Vue.router = router
Vue.use(require('@websanova/vue-auth'), {
  auth: require('@websanova/vue-auth/drivers/auth/bearer.js'),
  http: require('@websanova/vue-auth/drivers/http/axios.1.x.js'),
  router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js'),
  parseUserData: function (data) {
    return new User(data)
  }
})

require('./assets/scss/main.scss')
require('./translations/localization')
require('./bootstrap')
require('./icons')
require('./plugins/toaster')

loadProgressBar()

new Vue({
  render: h => h(App),
  router,
  store
}).$mount('#app')
